import { render, staticRenderFns } from "./Wishlist.vue?vue&type=template&id=05226c04&scoped=true"
import script from "./Wishlist.vue?vue&type=script&lang=ts"
export * from "./Wishlist.vue?vue&type=script&lang=ts"
import style0 from "./Wishlist.vue?vue&type=style&index=0&id=05226c04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05226c04",
  null
  
)

export default component.exports